import React, { useRef } from "react";
import { useUserContext } from "../context/userContext";

const Signup = () => {
  const emailRef = useRef();
  const nameRef = useRef();
  const psdRef = useRef();
  const { registerUser } = useUserContext();

  const onSubmit = (e) => {
    e.preventDefault();
    const email = emailRef.current.value;
    const name = nameRef.current.value;
    const password = psdRef.current.value;
    if (email && password && name){
      registerUser(email, password, name)
    } else {
      alert('Je hebt niet alle velden ingevuld')
    };;
  };

  return (
    <div>
      <form onSubmit={onSubmit}>
        <input placeholder="Email" type="email" ref={emailRef} />
        <input placeholder="Naam" type="name" ref={nameRef} />
        <input placeholder="Wachtwoord" type="password" ref={psdRef} />
        <button type="submit" className="buttonOrange">Registreer</button>
      </form>
      <h3> - of - </h3>
    </div>
  );
};

export default Signup;
